export default function campaignFactory() {
    // Assert that the BSCS is ubiquitous and always available
    const BSCS = window.adacado.bscs
  
    // Get unique token from BSCS as part of initialization
    const myToken = BSCS.getToken()
  
    return {
      // Create a new campaign
      create(campaign, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'POST',
          requestPath: `/campaign/v2/create`,
          requestParameters: [],
          payload: converttoJson(campaign)
        })
      },
    
      // Get campaign by advertiserId/campaignId
      get(campaignId, callback) {
        return BSCS.doRequest({
          myToken,
          requestMethod: 'GET',
          requestPath: `/campaign/v2/get/:cai`,
          requestParameters: [
            { key: 'cai', value: campaignId }
          ],
          callback: (campaign, token, annotation) => {
            // these keys may or may not exist, so need sanity checks
            if (campaign) {
              if (campaign.Properties && typeof campaign.Properties == 'string') {
                campaign.Properties = JSON.parse(campaign.Properties)
              }
              if (campaign.dspconfig && typeof campaign.dspconfig == 'string') {
                campaign.dspconfig = JSON.parse(campaign.dspconfig)
              }
              campaign.usedsp = campaign.usedsp == 'true' // BS is saving booleans as strings
            }
            callback(campaign, token===myToken, annotation)
          }
        })
      },
      getFromHeader(campaignId, callback, errorCallback) {
        return BSCS.doRequest({
          myToken,
          requestMethod: 'GET',
          requestPath: `/campaign/v2/headerget/:cai`,
          requestParameters: [
            { key: 'cai', value: campaignId }
          ],
          callback: (campaign, token, annotation) => {
            // these keys may or may not exist, so need sanity checks
            if (campaign) {
              if (campaign.Properties && typeof campaign.Properties == 'string') {
                campaign.Properties = JSON.parse(campaign.Properties)
              }
              if (campaign.dspconfig && typeof campaign.dspconfig == 'string') {
                campaign.dspconfig = JSON.parse(campaign.dspconfig)
              }
              campaign.usedsp = campaign.usedsp == 'true' // BS is saving booleans as strings
            }
            callback(campaign, token===myToken, annotation)
          },
          errorCallback: (error) => {
            errorCallback(error)
          }
        })
      },
    
      // Get list of campaigns by advertiserId
      getList(advertiserId, callback) {
        return BSCS.doRequest({
          myToken,
          requestMethod: 'GET',
          requestPath: `/campaign/v2/getlist/:adi/`,
          requestParameters: [
            { key: 'adi', value: advertiserId },
          ],
          callback: (campaigns, token, annotation) => {
            campaigns.sort((a, b) => {
              if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                return -1
              }
              if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
                return 1
              }
              return 0
            })
            callback(campaigns, token===myToken, annotation)
          }
        })
      },
  
      // Update a campaign  
      update(campaign, annotation) {
        // Sanity check - Uphold data contract to BE
        if (campaign.usedsp !== undefined && typeof campaign.usedsp !== 'string') {
          campaign.usedsp = campaign.usedsp.toString()
        }
        if (campaign.dspconfig !== undefined && typeof campaign.dspconfig !== 'string') {
          campaign.dspconfig = JSON.stringify(campaign.dspconfig)
        }
  
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/update`,
          payload: converttoJson(campaign)
        })
      },
  
      // Update Status property by Campaign Id
      updateStatus(status, campaignId, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/updatestatus/:cai`,
          requestParameters: [{ key: 'cai', value: campaignId }],
          payload: status
        })
      },
  
      // Update Start Date property by Campaign Id
      updateStartDate(startDate, campaignId, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/updatestartdate/:cai`,
          requestParameters: [{ key: 'cai', value: campaignId }],
          payload: converttoJson(startDate)
        })
      },
  
      // Update End Date property by Campaign Id
      updateEndDate(endDate, campaignId, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/updateenddate/:cai`,
          requestParameters: [{ key: 'cai', value: campaignId }],
          payload: converttoJson(endDate)
        })
      },
  
      // Update DSP Config property by Campaign Id
      updateDspConfig(campaignId, dspConfig, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/updatedspconfig/:cai`,
          requestParameters: [{ key: 'cai', value: campaignId }],
          payload: converttoJson(dspConfig)
        })
      },
  
      // Update Use DSP property by Campaign Id
      updateUseDsp(campaignId, isUsingDsp, annotation) {
        return BSCS.doRequest({
          myToken,
          annotation,
          requestMethod: 'PUT',
          requestPath: `/campaign/v2/updateusedsp/:cai/${isUsingDsp}`,
          requestParameters: [{ key: 'cai', value: campaignId }],
          payload: ''
        })
      }
    }
  }
  
  function converttoJson(obj) {
    const newObj = JSON.parse(JSON.stringify(obj))
    if (newObj.Properties && typeof newObj.Properties === 'object') {
      newObj.Properties = JSON.stringify(newObj.Properties);
    }
    return JSON.stringify(newObj);
  }